import './Sealnums.scss';

import React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteNode } from 'react-router5';

import Frame from '../Frame/Frame';
import Popup from "../../Components/Popup/Popup"
import { STORE_CONFIG } from '../../Store/ConfigStore';
import { ROUTE_SEALNUMS } from '../../routes';
import { STORE_SEALNUMS } from '../../Store/SealnumsStore';

@inject(stores => ({
    store: stores.store.get(STORE_SEALNUMS),
    socket: stores.socket,
    router: stores.router
}))
@observer
class Sealnums extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            popup: 'none',
            popupText: '',
            popupButtons: null,
            selected: null,
            newsealnum: ''
        }

        this.refresh()
    }
    
    refresh() {
        this.getSealnums()
    }

    getSealnums() {
        const obj = this
        this.props.socket.emitWithToken('GetSealnums', {}, function (err, data) {
            if (err) {
                console.error(err)
                return
            }
            console.log(data)
            obj.props.store.setSealnums(data)
        })
    }

    handleAddClick() {

        const newsealnum = this.state.newsealnum

        if (!newsealnum) {
            this.setState({
                popup: true,
                popupText: 'Hiányos adatok!'
            })
            return
        }

        const obj = this
        this.props.socket.emitWithToken('InsertSealnum', {Sealnum: newsealnum}, function (err, data) {
            if (err) {
                obj.setState({
                    popup: true,
                    popupText: err
                })
                return
            }
            obj.refresh()
            obj.setState({
                newsealnum: ''
            })
        })
    }

    handleDeleteClick(sealnum) {

        const data = sealnum

        const buttons = <div className='popup_buttons_wrapper'>
            <span className='popup_button' onClick={e => { this.setState({ popup: 'none' }), this.deleteData(data) }}>Igen</span>
            <span className='popup_button' onClick={e => this.setState({ popup: 'none' })}>Mégse</span>
        </div>

        this.setState({
            popup: 'delete',
            popupText: 'Biztosan törli?',
            popupButtons: buttons
        })
    }

    deleteData(sealnum) {
        const obj = this
        this.props.socket.emitWithToken('DeleteSealnum', {Sealnum: sealnum}, function (err, data) {
            if (err) {
                obj.setState({
                    popup: true,
                    popupText: err
                })
                return
            }
            obj.refresh()
            obj.setState({
                newsealnum: ''
            })
        })
    }

    render() {

        let table = this.props.store.sealnums.map(sealnum => {
            const className = 'database_listelement' + (this.state.selectedItem == sealnum ? ' selected' : '')
            const deleteClassName = 'delete_data' + (this.state.selectedItem == sealnum ? ' inverse' : '')
            return <tr class={className} onClick={() => this.setState(prevState => { return { selected: prevState.selected == sealnum ? null : sealnum } })}>
                <td className='database_cell'>
                    {sealnum}
                    <div className={deleteClassName} onClick={e => this.handleDeleteClick(sealnum)}></div>
                </td>
            </tr>
        })



        return <Frame>
            <div className="database basic-content">
                <div className="database__content">

                    <div className='database_list_tab'>
                        <div className='database_list_header'>FÉMZÁRSZÁMOK</div>

                        <div className='input_row'>
                            <div className='search-wrapper'>
                                <input className='search-input' placeholder='Új fémzárszám' value={this.state.newsealnum} onChange={e => this.setState({ newsealnum: e.target.value })} />
                            </div>
                            <div className='input_add' onClick={() => this.handleAddClick()}>+</div>
                        </div>

                        <div className='database_list scrollable'>
                            <table>{table}</table>
                        </div>
                    </div>

                </div>
            </div>
            {this.state.popup == 'none' ? null : <Popup key='popup' text={this.state.popupText} buttons={this.state.popup == 'delete' ? this.state.popupButtons : null} showCloseButton={this.state.popup == 'delete' ? false : true} onClickClose={() => this.setState({ popup: 'none' })} />}
        </Frame>
    }
}

export default (props) => <RouteNode nodeName={ROUTE_SEALNUMS}>
    {routeProps => <Sealnums {...routeProps} {...props} />}
</RouteNode>